import { render, staticRenderFns } from "./ModerationTab.vue?vue&type=template&id=57ea328a&scoped=true&"
import script from "./ModerationTab.vue?vue&type=script&lang=js&"
export * from "./ModerationTab.vue?vue&type=script&lang=js&"
import style0 from "./ModerationTab.vue?vue&type=style&index=0&id=57ea328a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ea328a",
  null
  
)

export default component.exports